import { render, staticRenderFns } from "./SelectAddNewUserType.vue?vue&type=template&id=242f2a2a"
import script from "./SelectAddNewUserType.vue?vue&type=script&lang=js"
export * from "./SelectAddNewUserType.vue?vue&type=script&lang=js"
import style0 from "./SelectAddNewUserType.vue?vue&type=style&index=0&id=242f2a2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports